import { ShowToast, Severty } from "../helper/toast";
import useRequest from "../hooks/useRequest";

const ConfirmationBox = () => {

  const { request } = useRequest();

  const showConfirm = ({record, path, onLoading, onSuccess, type}) => {
    statusChange(record, path, onLoading, onSuccess, type);
  };

  const statusChange = (record, path, onLoading, onSuccess, type) => {
    onLoading(true);
   
    let url = '';
    
    if(type !== null && type !== undefined){
      url   =   path + "/" + type + "/" + record
    }else{
      url   =   path + "/" + record
    }

    request({
      url: url,
      method: 'GET',
      onSuccess: (data) => {
        onSuccess();
        onLoading(false);
      },
      onError: (error) => {
        onLoading(false);
        onSuccess();
        ShowToast(error?.response?.data?.message, Severty.ERROR)
      }
    })
  };

  return { showConfirm }

};

export default ConfirmationBox;